import React from "react";
import Icon from "./Icon";
import { lighten, darken, displayColor } from "../lib/theme";

// "High-tech glass" icon tile: deep tinted glass, bright rim light, soft glow, glossy top sheen.
// Same props as before, so every screen picks it up with no other change.
export default function IconTile({ name, color = "#7C3AED", size = 52, radius, iconRatio = 0.52, className = "", floating = false }) {
  color = displayColor(color);
  const r = radius != null ? radius : Math.round(size * 0.3);
  return (
    <div
      className={`relative grid place-items-center shrink-0 overflow-hidden transition-transform duration-200 ${floating ? "group-hover:-translate-y-0.5 group-hover:scale-105" : ""} ${className}`}
      style={{
        width: size,
        height: size,
        borderRadius: r,
        background: `radial-gradient(120% 120% at 25% 15%, ${lighten(color, 38)} 0%, ${color} 48%, ${darken(color, 40)} 100%)`,
        border: "1px solid rgba(255,255,255,0.55)",
        boxShadow: `0 10px 22px -8px ${color}cc, 0 0 0 1px ${darken(color, 30)}55, inset 0 1.5px 0 rgba(255,255,255,0.75), inset 0 -8px 14px ${darken(color, 45)}66`,
      }}
      aria-hidden
    >
      <div
        style={{
          position: "absolute", left: "6%", right: "6%", top: "4%", height: "46%",
          borderRadius: `${Math.round(r * 0.9)}px ${Math.round(r * 0.9)}px ${Math.round(r * 1.6)}px ${Math.round(r * 1.6)}px`,
          background: "linear-gradient(180deg, rgba(255,255,255,0.55) 0%, rgba(255,255,255,0.06) 100%)",
          pointerEvents: "none",
        }}
      />
      <Icon name={name} width={size * iconRatio} height={size * iconRatio} strokeWidth={2.1}
        style={{ position: "relative", color: "#fff", filter: `drop-shadow(0 0 5px ${lighten(color, 60)}) drop-shadow(0 1px 1px rgba(0,0,0,0.25))` }} />
    </div>
  );
}
